import { automatorTemplates } from "../script-templates";

export const automator = {
  categoryNames: [
    "Time Studies",
    "Event Triggers",
    "Alter Settings",
    "Information",
    "Script Flow",
  ],
  commands: [
    {
      id: 0,
      isUnlocked: () => true,
      keyword: "STUDIES RESPEC",
      category: 0,
      syntax: `<b>studies respec</b>`,
      description: `Эта команда включает опцию сброса, которая сбросит Временны́е Исследования на следующей ручной или
        автоматической Вечности. Заметьте, что это не заканчивает Вечность само по себе; убедитесь, что ваш АвтоПокупщик
        включен или что вы вручную введёте команду ETERNITY (хотя ETERNITY имеет встроенную опцию сброса).`,
      examples: [
        `studies respec`,
      ]
    },
    {
      id: 1,
      isUnlocked: () => true,
      keyword: "STUDIES LOAD",
      category: 0,
      syntax: `<b>studies</b> [nowait] <b>load id</b> <u>selector</u><br>
        <b>studies</b> [nowait] <b>load name</b> <u>name</u>`,
      description: `Загружает пресет Временны́х Исследований, как если бы вы кликнули на кнопку во вкладке Временны́х
        Исследований.`,
      sections: [
        {
          name: "INPUTS",
          items: [
            {
              header: "<i>nowait</i>",
              description: `
                Если представлена, Автоматизатор купит как можно больше исследований перед продолжением. По стандарту,
                (т.е. без "nowait") эта команда будет повторять данную строку непоределённое количество раз, пока все
                указанные в пресете исследования не будут куплены; это может привести к застреванию Автоматизатора,
                если вы неосторожны.
              `
            },
            {
              header: "<i>selector</i>",
              description: `
                Находит и загружает указанный пресет Временны́х Исследований по номеру слота. Они нумерованы от 1 до 6,
                слева направо.`
            },
            {
              header: "<i>name</i>",
              description: "Находит и загружает указанный пресет Временны́х Исследований по заданному имени. " +
                "Чувствительно к регистру."
            },
          ]
        }
      ],
      examples: [
        `studies load id 2`,
        `studies load name ANTI`,
        `studies nowait load name dil`,
      ]
    },
    {
      id: 2,
      isUnlocked: () => true,
      keyword: "STUDIES PURCHASE",
      category: 0,
      syntax: `<b>studies</b> [nowait] <b>purchase <u>study_list</u></b>`,
      description: "Купить Временны́е Исследования, указанные в списке Временны́х Исследований.",
      sections: [
        {
          name: "INPUTS",
          items: [
            {
              header: "<i>nowait</i>",
              description: `
                Если представлена, Автоматизатор купит как можно больше исследований перед продолжением. По стандарту,
                (т.е. без "nowait") эта команда будет повторять данную строку непоределённое количество раз, пока все
                указанные в пресете исследования не будут куплены; это может привести к застреванию Автоматизатора,
                если вы неосторожны.
              `
            },
            {
              header: "<i>study_list</i>",
              description: `
                Формат экспортированного древа Временны́х Исследований поддерживается здесь. Он является списком ID
                Временны́х Исследований, разделенных запятой. Эта команда также поддерживает более подвижное
                форматирование, дополнительно позволяя диапазоны исследований (например, <u>11-62</u>) и следующие
                сокращения: <br>
                <blockquote><b>antimatter, infinity, time, active, passive, idle, light, dark</b></blockquote>
                Название переменной может быть использовать вместо списка Временны́х Исследований (смотрите панель
                определения), хотя в таком случае диапазоны и сокращения недоступны.`
            },
          ]
        }
      ],
      examples: [
        "studies nowait purchase 11,21,31",
        "studies purchase 11-62, antimatter, 111, idle",
        "studies nowait purchase ec6Studies",
      ]
    },
    {
      id: 3,
      isUnlocked: () => true,
      keyword: "PRESTIGE",
      category: 1,
      syntax: `
        <b>infinity</b> [nowait]<br>
        <b>eternity</b> [nowait] [respec]<br>
        <b>reality</b> [nowait] [respec]`,
      description: `Делает сброс Бесконечности, Вечности или Реальности, если возможно, в обратном случае Автоматизатор
        остановится на этой команде и будет ждать, пока её выполнение станет возможно. Если вы обнаружили, что ваш
        скрипт часто застревает на этой команде, АвтоПокупщик может активировать престиж до того как Автоматизатор
        достигает этой строчки - рассмотрите использование <i>nowait</i> или откорректируйте настройки Автоматизатора
        используя AUTO.`,
      sections: [
        {
          name: "МОДИФИКАТОРЫ",
          items: [
            {
              header: "<i>nowait</i>",
              description: `
                Если представлена, Автоматизатор сдвинется к следующей команде, вместо того чтобы бесконечно
                пытаться выполнить эту команду в ситуациях, когда это невозможно (например внутри ВЧ ниже цели).
              `
            },
            {
              header: "<i>respec</i>",
              description: `
                Для всех, кроме Бесконечности. Помимо прочего, включает определённое действие сброса после престижа.
                Вечность: Сбросить Временны́е Исследования и Вечность.<br>
                Реальность: Снять Глифы и Реальность.
              `
            },
          ]
        }
      ],
      examples: [
        "infinity",
        "eternity respec",
        "reality nowait",
      ]
    },
    {
      id: 4,
      isUnlocked: () => true,
      keyword: "UNLOCK",
      category: 1,
      syntax: "<b>unlock</b> [nowait] <u>feature</u>",
      description: "Разблокирует определённый Вечный Челлендж или Растяжение Времени.",
      sections: [
        {
          name: "МОДИФИКАТОРЫ",
          items: [
            {
              header: "<i>nowait</i>",
              description: `
                Если представлено, Автоматизатор сдвинется к следующей команде, даже если функция разблокировки
                не выполнится. По стандарту, Автоматизатор будет пытаться выполнить команду пока у него не получится.
              `
            },
          ]
        }
      ],
      examples: [
        "unlock dilation",
        "unlock ec7"
      ]
    },
    {
      id: 5,
      isUnlocked: () => true,
      keyword: "START",
      category: 1,
      syntax: `
        <b>start</b> ec<u>N</u><br>
        <b>start</b> dilation`,
      description: `Начать определённый Вечный Челлендж или Растянутую Вечность. Эта команда также пытается
        разблокировать ВЧ, если он не открыт, но не будет делать то же самое для Растяжения (используйте команду UNLOCK
        для того чтобы сделать это). Если вы уже находитесь внутри заданного ВЧ или Растянутой Вечности, запуск этой
        команды вновь ничего не изменит; иначе, Автоматизатор будет пытаться начать Вечность до тех пор, пока у него не
        получится.`,
      examples: [
        "start ec12",
        "start dilation"
      ]
    },
    {
      id: 6,
      isUnlocked: () => true,
      keyword: "AUTO",
      category: 2,
      syntax: `<b>auto infinity</b> [setting]<br>
        <b>auto eternity</b> [setting]<br>
        <b>auto reality</b> [setting]`,
      description: `Включает или выключает АвтоПокупщики престижа и позволяет вам менять их настройки. Если опция
        настроек не представлена, эта команда переключит статус АвтоПокупщика, выключая его, если он включен, и
        включая его, если он выключен. <b> Эта команда не будет работать если вы попытаетесь модифицировать АвтоПокупщик
        или настройку, которую вы ещё не открыли. </b>`,
      sections: [
        {
          name: "НАСТРОЙКИ",
          items: [
            {
              header: "<i>on</i> | <i>off</i>",
              description: "Включает или выключает заданный АвтоПокупщик.",
            },
            {
              header: "<u><i>number</i></u> <u><i>time units</i></u>",
              description: `Используется только с Бесконечностью или Вечностью.
                Включить АвтоПокупщик и установить его на срабатывание после заданного интервала.`
            },
            {
              header: "<u><i>number</i></u> x highest",
              description: `Используется только с Бесконечностью или Вечностью. Включить АвтоПокупщик и установить на
                режим "в X раз больше наибольших".`
            },
            {
              header: "<i><u>number</u> <u>currency</u></i>",
              description: `Включает АвтоПокупщик и устанавливает его на срабатывание при определённом количестве.
                Валюта должна соответствовать типу АвтоПокупщика (ОБ, ОВ или МР). Это выберет режим "Машины Реальности"
                для АвтоПокупщика Реальности. Режим Уровня Глифов не может быть изменён через АвтоМатизатор, только
                вручную.`,
            },
          ]
        }
      ],
      examples: [
        "auto infinity on",
        "auto eternity off",
        "auto infinity 30s",
        "auto eternity 10 seconds",
        "auto eternity 1e100 x highest"
      ]
    },
    {
      id: 7,
      isUnlocked: () => BlackHole(1).isUnlocked,
      keyword: "BLACK HOLE",
      category: 2,
      syntax: "<b>black hole</b> <u>state</u>",
      description: `Переключает эффект ускорения от Чёрной Дыры между вкл и выкл. Включение Чёрной Дыры через
        Автоматизатор не обходит постепенное увеличение скорости до максимума, которое происходит до того, как
        дыры становятся постоянными.`,
      examples: [
        "black hole on",
        "black hole off",
      ]
    },
    {
      id: 8,
      isUnlocked: () => Enslaved.isUnlocked,
      keyword: "STORE GAME TIME",
      category: 2,
      syntax: "<b>store game time</b> <u>action</u>",
      description: `Изменяет то, накапливает ли Чёрная Дыра время. Также позволяет использовать накопленное время.`,
      sections: [
        {
          name: "ДЕЙСТВИЯ",
          items: [
            {
              header: "<i>on</i> | <i>off</i>",
              description: `
                Переключает накопление игрового времени между вкл и выкл.
              `
            },
            {
              header: "<i>use</i>",
              description: `
                Использует всё накопленное время. Не меняет состояние накопления.
              `
            }
          ]
        }
      ],
      examples: [
        "store game time on",
        "store game time off",
        "store game time use",
      ]
    },
    {
      id: 9,
      isUnlocked: () => true,
      keyword: "NOTIFY",
      category: 3,
      syntax: "<b>notify</b> \"<u>text</u>\"",
      description: `Принимает текст и показывает его в правом верхнем углу в качестве текстового уведомления,
        в таком же месте и с таким же стилем как другие уведомления, такие как авто сохранение и разблокировка
        достижений. Может быть полезно для демонстрации статуса Автоматизатора других вкладках.`,
      examples: [
        "notify \"Dilation reached\"",
        "notify \"ECs completed\""
      ]
    },
    {
      id: 10,
      isUnlocked: () => true,
      keyword: "Добавление комментариев",
      category: 3,
      syntax: "<b>#</b> text<br><b>//</b> text",
      description: `Позволяет вам оставлять заметки для себа самого внутри скрипта. Может быть полезно для организации
        или отслеживания частей скрипта, делающих разные вещи, способом, являющимся более простым, чем чтение команд.
        Эти команды в основном служат инструментом помощи в отслеживании шагов скрипта.`,
      sections: [
        {
          name: "ПРИМЕЧАНИЯ",
          items: [
            {
              header: "<i>Встраиваемые комментарии</i>",
              description: `
                Автоматизатор не поддерживает комментарии, которые указываются после функциональной строки кода,
                на той же строке. В качестве примера, строка "studies load name TDI // Load push"
                будет считана как неверная команда. В таком случае, вам придется подвинуть комментарий на отдельную
                строку кода.
              `
            },
            {
              header: "<i>Скорость выполнения</i>",
              description: `
                Наличие комментариев не замедлит ваш скрипт, так как они полностью пропускаются во время выполнения
                и не считываются как команды. Например, даже если вы имеете очень длинноео объяснение в форме
                комментариев на линиях 20-40, Автоматизатор <i>мгновенно</i> переключится с линии 19 на линию
                41 при выполнении скрипта.
              `
            },
          ]
        }
      ],
      examples: [
        "# get 1e20 before starting ec1",
        "// this loop alternates dilation and pushing"
      ]
    },
    {
      id: 11,
      isUnlocked: () => true,
      keyword: "WAIT",
      category: 4,
      syntax: "<b>wait</b> <u>condition</u>",
      description: `Заставляет Автоматизатор подождать некоторое условие или событие. Чтобы подождать определённое
        количество секунд, используйте команду PAUSE.`,
      sections: [
        {
          name: "ВОЗМОЖНЫЕ УСЛОВИЯ",
          items: [
            {
              header: "<i>comparison</i>",
              description: `
                Ждёт, пока утверждение верно. Смотрите раздел "Форматирование Сравнений" для подробностей о том,
                как правильно использовать данную опцию.
              `
            },
            {
              header: "<i>prestige</i>",
              description: `
                Ждёт, пока указанный престиж (Бесконечность, Вечность или Реальность) будет завершён соответствующим
                АвтоПокупщиком. Это должно произойти <i>после</i> того, как достигнута эта команда; если АвтоПокупщик
                срабатывает <i>до</i> того, как команда достигнута, скрипт может застрять.
              `
            },
            {
              header: "<i>black hole (state)</i>",
              description: `
                Ждёт, пока Черная Дыра(Дыры) не перейдут в указанное состояние. Доступные состояния включают
                "off", "bh1" и "bh2".<br>
                off - ни одной активной чёрной дыры.<br>
                bh1 - хотя бы первая чёрная дыра активна.<br>
                bh2 - обе Чёрных Дыры активны.
              `
            }
          ]
        }
      ],
      examples: [
        "wait am >= 1e308",
        "wait pending completions >= 5",
        "wait ec9 completions >= 4",
        "wait infinity",
        "wait black hole bh1",
      ]
    },
    {
      id: 12,
      isUnlocked: () => true,
      keyword: "PAUSE",
      category: 4,
      syntax: "<b>pause</b> <u>interval</u>",
      description: `Приказывает автоматизатору прекратить выполнение команд на указанный промежуток времени.
        Заметьте, что если продолжительность паузы короче, чем скорость выполнения автоматизатора, автоматизатор будет
        ждать пока слудующий тик выполнения не наступит.`,
      examples: [
        "pause 10s",
        "pause 1 minute",
        "pause 34 seconds"
      ],
      sections: [
        {
          name: "ФОРМАТИРОВАНИЕ ИНТЕРВАЛОВ",
          items: [
            {
              header: "<i>Specified Interval</i>",
              description: `Эта команда принимает единицы измерения времени в миллисекундах ("ms"), секундах
              ("s", "sec", or "seconds"), минутах ("m", "min", or "minutes") и часах ("h" or "hours"). Вы не можете
              предоставить только число и ничего более; единица измерения времени должна быть указана.`,
            },
            {
              header: "<i>Defined Constant</i>",
              description: `Определённая константа может быть использована взамен, смотрите панель определения.
              Определённое значение будет взято в качестве количества секунд.`
            },
          ]
        },
        {
          name: "ДРУГОЕ",
          items: [
            {
              header: "<i>Offline Side-effects</i>",
              description: `Эта команда может вести себя нежелательно, когда она работает в офлайне, из-за
                количество тиков при подсчёте офлайн прогресса. 1-секундная пауза, которая обычно длится 20-30 тиков,
                может продлится только 1 игровой тик, когда идёт обработка часов офлайн прогресса, чего может быть
                недостаточно для ресурсов, необходимых для остальной части скрипта.`,
            },
            {
              header: "<i>Alternatives</i>",
              description: `Использование других команд, таких как 'WAIT' позволит вам установить ожидание
                до определённого количества ресурса, чтобы удостовериться в том, что игра находится в необходимом
                для продолжения скрипта состоянии.`
            },
            {
              header: "<i>Manual Skip</i>",
              description: `Вы можете вручную заставить автоматизатор продолжить выполнение скрипта после команды PAUSE
                без ожидания обозначенного времени путём нажатия кнопки перехода на следующую строку, а затем
                продолжения скрипта. Если вы делаете это регулярно, задумайтесь об изменении скрипта.`
            }
          ]
        }
      ]
    },
    {
      id: 13,
      isUnlocked: () => true,
      keyword: "IF",
      category: 4,
      syntax: `<b>if</b> <u>condition</u> {<br>
        <blockquote>commands</blockquote>
        }`,
      description: `Определяет внутренний блок блока скрипта автоматизатора, который будет выполнен только в случае,
        если заданное сравнение окажется истиным на момент достижения этой строчки. Если сравнение ложно, автоматизатор
        промотает скрипт до следующей строки после блока и продолжит выполнение кода оттуда.`,
      examples: [
        "if ec10 completions < 5",
        "if ep > 1e6000"
      ]
    },
    {
      id: 14,
      isUnlocked: () => true,
      keyword: "UNTIL",
      category: 4,
      syntax: `<b>until</b> <u>comparison</u> {<br>
        <blockquote>commands</blockquote>
        }<br><b>until</b> <u>prestige_event</u> {<br>
          <blockquote>commands</blockquote>
        }`,
      description: `Определяет внутренний блок скрипта, команды в котором будут повторяться; сравнение проверяется
        в начале и каждый раз, когда петля перезапускается. Если условие истино, когда выражение UNTIL достигнуто
        впервые, внутренний блок команд будет полностью пропущен.
        <br><br>
        Если событие престижа (т.е. Бесконечность, Вечность или Реальность) указано вместо уловия, то блок кода
        всегда будет исполнен и команды будут повторяться до тех пор, пока событие не произойдет впервые
        <i>после</i> входа в блок. Заметьте, что Автоматизатор закончит остальную часть петли и только потом выйдет из
        блока кода, а не сделает это сразу, как только событие престижа произойдёт.`,
      examples: [
        "until ep > 1e500",
        "until reality",
      ]
    },
    {
      id: 15,
      isUnlocked: () => true,
      keyword: "WHILE",
      category: 4,
      syntax: `<b>while</b> <u>comparison</u> {<br>
        <blockquote>commands</blockquote>
      }`,
      description: `Определяет внутренний блок скрипта, в котором повторяются команды; сравнение происходит впервые
        и каждый раз, когда петля повторяется. Если условие ложно, когда условие WHILE впервые достигнуто, то внутренний
        блок команд будет полностью пропущен.`,
      examples: [
        `while ep < 1e500`,
        `while myThreshold > am`,
      ]
    },
    {
      id: 16,
      isUnlocked: () => true,
      keyword: "STOP",
      category: 4,
      syntax: `<b>stop</b>`,
      description: `Когда автоматизатор запускает эту строку, он остановит выполнение так же, как сделал бы это, если
        бы вы нажали кнопку <i class="fas fa-stop"></i> на панели управления в левом верхнем углу Автоматизатора. Это
        не нужно помещать в конец каждого скрипта для того чтобы остановить его, так как выключение опции
        <i class="fas fa-sync-alt"></i> на левой панели сделает это автоматически.
        Эта команда может быть полезна, когда использована внутри IF, для того чтобы остановить выполнение
        при определённых условиях.`,
      examples: [
        `stop`,
      ]
    },
    {
      id: 17,
      isUnlocked: () => true,
      keyword: "Currency List",
      category: 4,
      syntax: "<i>Вы можете использовать это внутри любых IF, WHILE, UNTIL или команды WAIT</i>",
      description: () => {
        const filterText = EffarigUnlock.glyphFilter.isUnlocked
          ? `<b>filter score</b> - Счёт фильтра Глифов для Глифа, выбранного в этой Реальности<br>`
          : "";
        const stText = V.spaceTheorems > 0
          ? `<b>space theorems</b> - Количество текущих неиспользованных Космических Теорем<br>
            <b>total space theorems</b> - ВСЕГО Космических Теорем, включая потраченные на текущие Исследования<br>`
          : "";
        return `Это список "валют" или чисел, которые вы можете использовать внутри Автоматизатора.<br>
          Заметьте, что когда использованы, большинство валют должно быть в научной форме записи.<br>
          <b>am</b> - Текущее количество Антиматерии  <br>
          <b>ip</b> - Текущее количество Очков Бесконечности  <br>
          <b>ep</b> - Текущее количество Очков Вечности  <br>
          <b>rm</b> - Текущее количество Машин Реальности  <br>
          <b>infinities</b> - Текущее количество Бесконечностей <br>
          <b>banked infinities</b> - Текущее количество Запасённых Бесконечностей <br>
          <b>eternities</b> - Текущее количество Вечностей <br>
          <b>realities</b> - Текущее количество Реальностей <br>
          <b>pending ip</b> - ОБ, зарабатываемые на Бесконечности (0 если недоступно)<br>
          <b>pending ep</b> - ОВ, зарабатываемые на Вечности (0 если недоступно)<br>
          <b>pending tp</b> - ТЧ, зарабатываемые на выходе из Растяжения<br>
          <b>pending rm</b> - МР, зарабатываемые на Реальности (0 если недоступно)<br>
          <b>pending glyph level</b> - Уровень Глифа, получаемый на Реальности (0 если недоступно)<br>
          <b>dt</b> - Текущее количество Растянутого Времени <br>
          <b>tp</b> - Текущее количество Тахион Частиц<br>
          <b>rg</b> - Текущее количество Галактик Репликантов (не использует научную)<br>
          <b>rep</b> - Текущее количество Репликантов <br>
          <b>tt</b> - Текущее количество Временны́х Теорем <br>
          <b>total tt</b> - ВСЕГО Временны́х Теорем, включая все формы сгенерированных ВИ и потраченные <br>
          <b>spent tt</b> - Количество Временны́х Теорем, потраченных на Временны́е Исследования <br>
          <b>total completions</b> - Всего прохождений всех Вечных Челленджей <br>
          <b>pending completions</b> - Всего прохождений текущих ВЧ после Вечности <br>
          <b>ec<u>X</u> completions</b> - Количество прохождений ВЧ за определенный ВЧ (например "ec6 completions")<br>
          ${filterText}
          ${stText}
        `;
      }
    },
    {
      id: 18,
      isUnlocked: () => true,
      keyword: "Formatting Comparisons",
      category: 4,
      syntax: "<u>resource1</u> <u>condition</u> <u>resource2</u>",
      description: `
        Сравнения используются внутри определённых команд, которые позволяют вам контролировать поведение скрипта на
        основе текущего состояния игры. Они имеют стандартную форму с двумя входами и оператором сравнения, однако
        значение входов может быть чем угодно до тех пор, пока корректно отформатировано.`,
      sections: [
        {
          name: "УСЛОВИЯ",
          items: [
            {
              header: "<i>resource</i>",
              description: `
                Это может быть любая Валюта Автоматизатора, определённая константа, или число, которое должно быть
                отформатировано в научную форму записи(например 1000, 1e100, 1.8e308). В отличии от более
                основных языков программирования, это должно быть одиночным значением
                (т.е. математические выражения, такие как "ip + pending ip" недопустимы).
              `
            },
            {
              header: "<i>condition</i>",
              description: `
                Это должно быть оператором неравенства (<, <=, >, >=). Он имеет привычное математическое значение.
                Операторы равенства (==, !=) недопустимы, так как природа игры такова, что числа никогда не будут
                полностью равны и поэтому проверка равенства может привести к неожиданному поведению скрипта.
              `
            },
          ]
        }
      ],
      examples: [
        "ep < 1e20",
        "total tt > 14000",
      ]
    },
    {
      id: 19,
      isUnlocked: () => true,
      keyword: "Commands with inner blocks",
      category: 4,
      syntax: `<b>header_command</b> {<br>
        <blockquote>inner_commands</blockquote>
        }`,
      description: `Некоторые команды ассоциируются с "внутренним блоком" команд. Внутренний блок может содержать
        любую другую допустимую команду, но может выполниться или не выполниться, в зависимости от состояния игры, при
        котором <b>header_command</b> выполняется. Это позволяет повторять некоторые команды вновь и вновь (например
        покупку Временны́х Исследований), или полностью пропускать их (например не заходить в ВЧ если он уже полностью
        пройден). Блоки могут находиться внутри других блоков.
        <br><br>
        В режиме текстового редактирования: Обозначьте внутренний блок с помощью фигурных скобок, с открывающейся
        скобкой { на той же линии, на которой сравнение и с закрывающейся скобкой на другой линии после последней строки
        блока, который вы хотите задать. Внутренние команды не должны быть выделены пробелами, но это рекомендуется.
        <br><br>
        В режиме редактирования блоков: Эти команды предоставляются с пустым прямоугольником, который допускает
        размещение команд внутри него.
        `,
      examples: [
        `if ec10 completions < 5 {<br>
          <blockquote>
          unlock ec10<br>
          start ec10</blockquote>
        }`,
        `until ep > 1e8 {<br>
          <blockquote>
          studies nowait purchase 11-62<br>
          pause 10s<br>
          eternity respec</blockquote>
        }`
      ]
    },
  ],
  otherAutomatorPoints: [
    {
      name: "Количество Реальностей",
      automatorPoints: () => 2 * Math.clampMax(Currency.realities.value, 50),
      shortDescription: () => `+${formatInt(2)} за Реальность, до ${formatInt(50)} Реальностей`,
      symbol: "Ϟ",
    },
    {
      name: "Чёрная Дыра",
      automatorPoints: () => (BlackHole(1).isUnlocked ? 10 : 0),
      shortDescription: () => `Разблокировка даёт ${formatInt(10)} ОА`,
      symbol: "<i class='fas fa-circle'></i>",
    },
  ],
  templates: automatorTemplates
};
